module.exports = __webpack_public_path__ + "static/image5-6e4f9aa20a6c8713bcd2291fb909f4b3.png";